import script from "./base-error.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-error.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__